import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import ItemViewer from '../components/Common/ItemViewer/ItemViewer';
import EnforcedTaskForm, { taskRequest } from '../components/Tasks/EnforcedTaskForm';

/** Серверный режим выбирает форму; legacy/shadow сохраняют прежний ItemViewer. */
const TaskScreen = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const reload = useCallback(async () => {
    const result = await taskRequest(`/api/directories/tasks/${id}`);
    setData(result);
    setRevision((previous) => previous + 1);
  }, [id]);

  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    taskRequest(`/api/directories/tasks/${id}`)
      .then((result) => { if (active) setData(result); })
      .catch((failure) => { if (active) setError(failure.message); });
    return () => { active = false; };
  }, [id]);

  if (error) return <Alert severity='error'>{error}</Alert>;
  if (!data) return <p>Загрузка задачи…</p>;
  if (data.mode !== 'enforce') return <ItemViewer slug='tasks' id={id} key={id} />;
  return <EnforcedTaskForm key={`${id}:${revision}`} id={id} initial={data} reload={reload} />;
};

export default TaskScreen;
